import { ReactNode } from 'react';
import { Paper, Box, Typography } from '@material-ui/core';

export const Panel = ({ title, subtitle, children, sx, action }) => (
  <Paper
    elevation={0}
    sx={{
      borderRadius: 3,
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      p: 3,
      boxShadow: '0 2px 10px -4px rgba(31,58,44,0.08)',
      ...sx
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        mb: 2.5
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ fontSize: 19 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action}
    </Box>
    {children}
  </Paper>
);
